import { Box, Typography, Stack } from "@mui/material";
import { motion } from "framer-motion";
import BookOnlineIcon from "@mui/icons-material/BookOnline";

function ReservationPromo() {
  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0, x: 30 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8 }}
      sx={{
        backgroundColor: "#FFFFFF", // jaune (Amber 500)
        boxShadow: 3,
        width: "100%",
        mx: "auto",
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={3}
        alignItems="center"
        justifyContent="space-between"
      >
        {/* Texte à gauche */}
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          flex={1}
          sx={{ p: 2 }}
        >
 

          <Typography
            component={motion.div}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            variant="h5"
            sx={{ color: "goldenrod" }} // titre en noir
          >
            Passez votre réservation en ligne dès maintenant : bénéficiez d’un taux préférentiel !
            <Typography
              variant="body2"
              sx={{ color: "#000000", mt: 1 }} // texte en noir
            >
              Présents à travers le Maroc, nos bureaux de change vous accueillent notamment au cœur de Marrakech : Centre-ville, Guéliz, Hivernage, et Médina. Réservez en ligne en quelques clics et réalisez votre opération de change rapidement et en toute sécurité.

            </Typography>
          </Typography>
        </Stack>

        {/* Exemple d’image si besoin */}
        {/*
        <Box
          component="img"
          src="/images/bureaux/regionale.jpg"
          alt="Réservation de devises"
          sx={{
            width: { xs: "100%", md: 180 },
            height: 120,
            objectFit: "cover",
            flexShrink: 0,
          }}
        />
        */}
      </Stack>
    </Box>
  );
}

export default ReservationPromo;
